<div class="bulb-input-label-wrapper">
  <label *ngIf="label"
         [for]="id"
         class="bulb-input-label-wrapper"
         [ngClass]="{'bulb-required': required}"
  >
    {{ label }}
  </label>
</div>
<p-multiSelect
  #input="ngModel"
  [id]="id"
  [name]="name"
  class="input"
  [dataKey]="dataKey"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [placeholder]="placeholder"
  [options]="options"
  [(ngModel)]="value"
  (ngModelChange)="onChange($event)">
</p-multiSelect>
<div class="bulb-error-wrapper">
    <span *ngIf="input.invalid && ( input.dirty || input.touched )"
          class="bulb-bottom-error-msg">
      {{ errorMessage }}
    </span>
</div>
